import { IAddOnWithQuantity } from "@/hooks/product-has-attrs/product-has-attrs-helpers/interfaces";

export const toggleOption = (
  state: any,
  key: any,
  is_multi_select: boolean,
) => {
  if (is_multi_select) {
    if (!state) return [key];
    let currentSelected = [...state];
    const index = currentSelected?.indexOf(key);
    const wasSelected = index > -1;
    wasSelected
      ? currentSelected?.splice(index, 1)
      : currentSelected?.push(key);
    return currentSelected.filter(Boolean);
  }
  return state[0] === key ? [] : [key];
};
export const isSelected = (state: any, key: any) => {
  return !state ? false : state?.indexOf(key) !== -1;
};

export const toggleAddonWithQuantity = (
  state: IAddOnWithQuantity[],
  key: number,
  is_multi_select: boolean,
  quantity: number,
): IAddOnWithQuantity[] => {
  if (is_multi_select) {
    if (!state) return [{ id: key, quantity }];
    let currentSelected = [...state];
    const index = currentSelected.map((addon) => addon.id)?.indexOf(key);
    const wasSelected = index > -1;
    wasSelected
      ? currentSelected?.splice(index, 1)
      : currentSelected?.push({ id: key, quantity });
    return currentSelected.filter(Boolean);
  }
  return state && state[0]?.id === key ? [] : [{ id: key, quantity }];
};

export const changeAddonQuantity = (
  state: IAddOnWithQuantity[],
  key: number,
  quantity: number,
) => {
  return state.map((addon) =>
    addon.id === key ? { ...addon, quantity } : { ...addon },
  );
};
export const isSelectedAddon = (state: IAddOnWithQuantity[], key: number) => {
  return !state ? false : state?.map((addon) => addon.id).indexOf(key) !== -1;
};
